module.exports = __webpack_public_path__ + "img/paintingBefore1.f0aecf86.png";